// breadcrumb.module.ts
import { NgModule } from '@angular/core';
import {
  OriBreadcrumbDirective,
  OriBreadcrumbItemDirective,
  OriBreadcrumbLinkDirective,
  OriBreadcrumbListDirective,
  OriBreadcrumbPageDirective,
  OriBreadcrumbSeparatorComponent,
  OriBreadcrumbEllipsisComponent
} from '~/components/ui/breadcrumb';
import {
  OriButton
} from '~/components/ui/button';
import { OriDialogComponent, OriDialogComponentNoRDX, OriDialogDescription, OriDialogFooter, OriDialogHeader, OriDialogTitle } from '~/components/ui/dialog';
import { RippleDirective } from '~/components/effects/ripple';
import { OriInput } from '~/components/ui/input';
import { OriBadgeComponent } from '~/components/ui/badge';

@NgModule({
  imports: [
    OriBreadcrumbDirective,
    OriBreadcrumbItemDirective,
    OriBreadcrumbLinkDirective,
    OriBreadcrumbListDirective,
    OriBreadcrumbPageDirective,
    OriBreadcrumbSeparatorComponent,
    OriBreadcrumbEllipsisComponent,
    OriButton,
    OriDialogComponentNoRDX,
    OriDialogHeader,
    OriDialogDescription,
    OriDialogTitle,
    OriDialogFooter,
    RippleDirective,
    OriInput,
    OriBadgeComponent
  ],
  exports: [
    OriBreadcrumbDirective,
    OriBreadcrumbItemDirective,
    OriBreadcrumbLinkDirective,
    OriBreadcrumbListDirective,
    OriBreadcrumbPageDirective,
    OriBreadcrumbSeparatorComponent,
    OriButton,
    OriDialogComponentNoRDX,
    OriDialogHeader,
    OriDialogDescription,
    OriDialogTitle,
    OriDialogFooter,
    RippleDirective,
    OriInput,
    OriBadgeComponent
  ]
})
export class BreadcrumbModule {}
